import { Form } from "@redriver/cinnamon-mui";
import { getVendors } from "./actions";

const VendorTypeAhead = (props) => (
  <Form.TypeAhead {...props} lookupAction={getVendors} />
);

export default VendorTypeAhead;
